export default {
    organizations: [],
    searchString: '',
    creativeCode: '',
    pageNumber: 1,
    pageSize: 25
  }